import {Container} from '@mantine/core'
import {createFileRoute} from '@tanstack/react-router'

import {GoogleMapsProvider} from 'src/jobs/google-maps/google-maps-provider'
import {ProjectDetailsPage} from 'src/projects/project-details-page'

export const Route = createFileRoute('/_app/projects/$projectId/')({
    component: ProjectDetailsRoute,
})

function ProjectDetailsRoute() {
    const {projectId} = Route.useParams()

    return (
        <Container size="lg" py="xl">
            <GoogleMapsProvider>
                <ProjectDetailsPage projectId={projectId} />
            </GoogleMapsProvider>
        </Container>
    )
}
